// React
import React from 'react';
// External
import {
    Button, Image, Row, Col, Modal
} from 'react-bootstrap';
import { HiOutlineDocumentDownload, HiOutlineMail, HiOutlinePhone } from 'react-icons/hi';
import { Link } from 'react-router-dom';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import HeaderDivider from 'components/shared/atoms/HeaderDivider/HeaderDivider';
import formatPhoneNumber from 'utils/formatPhoneNumber';
import BrandService from 'services/brand';
import VetService from 'services/vet';
import config from 'config/config';
// Style
import './styles.scss';
// Constants
import TAGGING_PROCESS from 'constants/taggingProcess';
import TAGGING_GUIDE_FILES from 'constants/taggingGuideFiles';

class TaggingGuide extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showContactCard: false,
            email: '',
            phoneNumber: '',
            brandName: '',
            fileUrl: '',
            taggingProcess: [],
        };
        this.getVetDetails();
    }

    /**
     * Gets the contact info of the brand
     */
    getBrandContact() {
        BrandService.getBrand(this.state.brandName)
            .then((response) => {
                this.setState({
                    email: response.data.email_addresses && response.data.email_addresses.length > 0
                        ? response.data.email_addresses[0].email_address : '',
                    phoneNumber: formatPhoneNumber(response.data.phone_work, 3)
                });
            }).catch((err) => {
                console.error(err);
            });
    }

    /**
     * Get Vet Detail
     */
    getVetDetails() {
        VetService.getVetDetails()
            .then((response) => {
                this.setState({ brandName: response.data.cstm.brand.name });
                this.getBrandContact();
                this.getFileUrl();
                this.getTaggingProcess();
            }).catch((err) => {
                console.error(err);
            });
    }

    /**
     * @todo Adjust the brands once is deployed and the brands are permanent
     * @returns {string} Returns the url of the tagging guide file
     */
    getFileUrl = () => {
        const brandFile = TAGGING_GUIDE_FILES.find((fileObj) => {
            return fileObj.brand === this.state.brandName;
        });
        this.setState({ fileUrl: brandFile.url });
    }

    getTaggingProcess = () => {
        if(this.state.brandName.includes("LWD")) {
            this.setState({ taggingProcess: TAGGING_PROCESS.tagsLW });
        }

        if(this.state.brandName.includes("EDH")) {
            this.setState({ taggingProcess: TAGGING_PROCESS.tagsEH });
        }

        if(this.state.brandName.includes("QLD")) {
            this.setState({ taggingProcess: TAGGING_PROCESS.tagsQLD });
        }

        if(this.state.brandName.includes("NSW")) {
            if (this.state.brandName.includes("PaP")) {
                this.setState({ taggingProcess: TAGGING_PROCESS.tagsPaP });
            } else {
                this.setState({ taggingProcess: TAGGING_PROCESS.tagsNSW });
            }
        }
    }    

    render() {
        return (
            <div>
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title="Tagging guide" />
                    <ContentCard
                        className="mt-62 tagging-content-card"
                        divider={false}
                        headerTitle="Tagging process"
                        headerBtnText="View more"
                        headerSubComponent={(
                            <p className="sub-header">
                                Understanding the tagging system ensures efficient turnaround.
                                The steps below will clarify how you can minimise delays in completion of bookings.
                            </p>
                        )}
                    >
                        <div className="tagging-container">
                            {
                                TAGGING_PROCESS.steps.map((step, index, arr) => (
                                    <div className="steps-container" key={index}>
                                        <HeaderDivider title={TAGGING_PROCESS.steps.length - 1 > index ? `Step ${index + 1}` : ''} />
                                        <p>
                                            {step}
                                        </p>
                                        {
                                            index === 1
                                                ? (
                                                    <div className="tagging-container">
                                                        {
                                                            this.state.taggingProcess.map((tag) => (
                                                                <Row key={tag.title}>
                                                                   <Row key={tag.title}>
                                                                    <Col>
                                                                        <Image src={tag.img} width={160} />
                                                                    </Col>
                                                                    <Col>
                                                                        <Image src={tag.imgBack} width={60} />
                                                                    </Col>
                                                                    <Col>
                                                                        <HeaderDivider title={tag.title} />
                                                                        <p className="newline">{tag.description}</p>
                                                                    </Col>
                                                                </Row>
                                                                </Row>
                                                            ))
                                                        }
                                                    </div>
                                                ) : null
                                        }
                                    </div>
                                ))
                            }
                        </div>
                        <div className="tag-contact-details">
                            <Button
                                className="tag-button"
                                onClick={() => this.setState({ showContactCard: true })}
                            >
                                Contact Client Care
                            </Button>
                            <Button
                                onClick={() => window.open(this.state.fileUrl, "_blank")}
                                className="tag-button"
                            >
                                <span>Download Tagging Guide</span>
                                <HiOutlineDocumentDownload size="20" />
                            </Button>
                        </div>
                    </ContentCard>
                </div>
                <Modal
                    className="contact-modal"
                    show={this.state.showContactCard}
                    onHide={() => this.setState({ showContactCard: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Contact Client Care</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <HeaderDivider
                            title={(
                                <span>
                                    <HiOutlineMail size="18" />
                                    Email:
                                    <a href={`mailto:${this.state.email}`} className="underline">{this.state.email}</a>
                                </span>
                            )}
                        />
                        <HeaderDivider
                            title={(
                                <span>
                                    <HiOutlinePhone size="18" />
                                    Phone:
                                    <a href={`tel:${this.state.phoneNumber}`} className="underline">{this.state.phoneNumber}</a>
                                </span>
                            )}
                        />
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default TaggingGuide;
